<template>
  <question-card hide-button>
    <template #title>
      {{UIComponentData.Header.Translations[questionnaireLead.Language]}}
    </template>
    <answer-icon-block>
      <answer-icon
        @click="answer(false)"
        image="no.svg"
        :checked="questionnaireLead.FirstTimeHomeBuyer === false"
      >
        {{UIComponentData.Choice2.Translations[questionnaireLead.Language]}}
      </answer-icon>
      <answer-icon
        @click="answer(true)"
        image="yes.svg"
        :checked="questionnaireLead.FirstTimeHomeBuyer === true"
      >
        {{UIComponentData.Choice1.Translations[questionnaireLead.Language]}}
      </answer-icon>
    </answer-icon-block>
  </question-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import QuestionCard from '@/components/QuestionCard.vue';
import AnswerIcon from '@/components/AnswerIcon.vue';
import AnswerIconBlock from '@/components/AnswerIconBlock.vue';

export default {
  name: 'first-home-step',
  components: {
    QuestionCard,
    AnswerIcon,
    AnswerIconBlock,
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
    UIId: Number
  },
  methods: {
    ...mapActions(['mutateLead']),
    async answer(value) {
      this.questionnaireLead.FirstTimeHomeBuyer = value;
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
          this.$emit('route-to-next-slide',true);
        }
        else{
          this.$emit('route-to-next-slide',false);
        }
      }
    },
  },
  computed: {
    ...mapGetters(['questionnaireLead']),
  }
};
</script>
